import { useRouteError } from 'react-router-dom'

// Definiamo un'interfaccia per l'errore
interface ErrorWithMessage {
  statusText?: string
  message?: string
}

export default function ErrorPage() {
  const error = useRouteError()
  console.error(error)

  // Verifichiamo se error è un oggetto con le proprietà che ci interessano
  const errorMessage = isErrorWithMessage(error)
    ? error.statusText || error.message
    : 'Errore sconosciuto'

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{errorMessage}</i>
      </p>
    </div>
  )
}

// Funzione di tipo per verificare se l'errore ha le proprietà che ci interessano
function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
  return (
    typeof error === 'object' && error !== null && ('statusText' in error || 'message' in error)
  )
}
